import React from "react";
import { graphql } from "gatsby";
import Layout from "../../components/Layout";
import WithI18next from "../../components/WithI18next";
import CampaignArticleLayout from "../../layouts/CampaignArticleLayout";

const Campaign = ({ data }) => {
  const campaign = data.campaignItem;

  return (
    <Layout title={campaign.seo.title} description={campaign.seo.metaDesc}>
      <CampaignArticleLayout content={campaign} />
    </Layout>
  );
};

export default WithI18next()(Campaign);

export const query = graphql`
  query ($id: Int!) {
    campaignItem: wpCampaignItem(databaseId: { eq: $id }) {
      title
      content
      acfCampaignDate {
        campaignEndDate
        campaignStartDate
      }
      seo {
        metaDesc
        title
      }
    }
  }
`;
